
  var _styles = {
  "coupon-item__wrapper": {
    "width": "7.65333rem",
    "height": "2.02667rem",
    "position": "relative",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start"
  },
  "coupon-item__background-img": {
    "width": "7.65333rem",
    "height": "2.02667rem",
    "position": "absolute",
    "top": 0,
    "left": 0,
    "zIndex": 0
  },
  "coupon-item__left-wrapper": {
    "position": "absolute",
    "left": 0,
    "zIndex": 1,
    "height": "100%",
    "width": "2.4rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "coupon-item__amount-wrapper": {
    "marginTop": "0.26667rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "baseline"
  },
  "coupon-item__amount-prefix": {
    "color": "rgb(255,45,25)",
    "marginRight": "0.05333rem",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "0.42667rem"
  },
  "coupon-item__amount-text": {
    "color": "rgb(255,45,25)",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "0.8rem"
  },
  "coupon-item__require-text": {
    "marginTop": "-0.13333rem",
    "fontWeight": "400",
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "textAlign": "center"
  },
  "coupon-item__middle-wrapper": {
    "position": "absolute",
    "left": "2.53333rem",
    "zIndex": 1,
    "height": "100%",
    "width": "4rem",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "flex-start"
  },
  "coupon-item__title-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem"
  },
  "coupon-item__desc-text": {
    "fontWeight": "400",
    "color": "rgb(255,198,193)",
    "fontFamily": "MT New Digital Display",
    "fontSize": "0.32rem"
  },
  "coupon-item__right-button": {
    "position": "absolute",
    "right": "0.32rem",
    "zIndex": 1,
    "width": "1.6rem",
    "height": "0.64rem",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "borderRadius": "0.32rem",
    "background": "#fff"
  },
  "coupon-item__button-text": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  